var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThoughtLeadership2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.75,48c0-3.582,4.15625-6.8916,4.26562-6.98438a12.75,12.75,0,1,0-17.96386.06006C31.09375,41.1084,35.25,44.40674,35.25,48a.7502.7502,0,0,0,.75.75h8A.7502.7502,0,0,0,44.75,48Zm-4-.75V32.75H44v-1.5H36v1.5h3.25v14.5H36.70508c-.47559-3.979-4.54-7.20752-4.66016-7.29492A11.25018,11.25018,0,1,1,48.02246,39.895c-.18359.14355-4.252,3.376-4.72754,7.355Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75,72V64.75H56A10.762,10.762,0,0,0,66.75,54V46.46338l1.7959-.898a2.74959,2.74959,0,0,0,1.23047-3.68994l-2.70606-5.41113a3.31644,3.31644,0,0,1-.335-1.38477A26.75146,26.75146,0,1,0,29.71094,60.69971l.57812-1.38477A25.25353,25.25353,0,1,1,56.96875,17.30127a25.04,25.04,0,0,1,8.2666,17.82861,4.82432,4.82432,0,0,0,.49317,2.00489l2.706,5.41162a1.24916,1.24916,0,0,1-.55859,1.67724L65.665,45.3291A.74888.74888,0,0,0,65.25,46v8A9.26032,9.26032,0,0,1,56,63.25H50v1.5h3.25V72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 51.25,
    width: 8,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThoughtLeadership2);
export default __webpack_public_path__ + "static/media/icon_thought_leadership_2.14d960c5c6198ef8bc88c6cb60184e2d.svg";
export { ForwardRef as ReactComponent };